import axios from 'axios';
import { customHistory } from './CustomBrowserRouter';
import { getLabel } from './utils/labelStore';

export const getError = (error) => {
	return error.response?.data?.message
		? error.response.data.message
		: error.message;
};
export const getStatus = (error) => {
	return error.response && error.response.status
		? error.response.status
		: error.message;
};
export const showCurrency = (currency, capital, list) => {
	if (list === 'debts') {
		if (!capital || capital === '' || capital === null) {
			return '';
		} else if (currency === 'UYU') {
			return '$U';
		} else if (currency === 'USD') {
			return 'U$S';
		}
	} else {
		if (currency === 'UYU') {
			return '$U';
		} else if (currency === 'USD') {
			return 'U$S';
		}
	}
};
//lists for dropdowns
export const types = ['Persona', 'Empresa'];
export const concepts = ['prestamos-amortizable', 'prestamos-interés', 'alquileres', 'ventas-a-plazo'];
export const periodicities = ['efectivo','mensual', 'semestral', 'anual', 'otra', 'eventual'];
export const currencies = ['USD', 'UYU'];
export const monthOptions = ['Mes actual', 'Mes siguiente', 'En tres meses', 'En seis meses', 'Otro'];
export const dueDays = Array.from({ length: 31 }, (_, index) => (index + 1).toString());
/**
 * @param {String} hex Six digit hexadecimal color
 * @param {Number} alpha Number between 0 and 1
 */
export const addAlphaToHex = (hex, alpha) => {
	let convertedColor = hex;
	if (hex.length === 6 && alpha > 0 && alpha <= 1) {
		const hexValues = hex.match(/.{1,2}/g);
		const rgbArray = [
			parseInt(hexValues[0], 16),
			parseInt(hexValues[1], 16),
			parseInt(hexValues[2], 16),
		];
		convertedColor = `rgb(${rgbArray[0]},${rgbArray[1]},${rgbArray[2]},${alpha})`;
	}
	return convertedColor;
};

export const regexEmail =
	/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

export async function refreshToken() {
	const refresTkn = localStorage.getItem('refreshToken');
	if (!refresTkn) {
		const error = new Error('No refresh token available');
		error.code = 'NO_REFRESH_TOKEN';
		throw error;
	}
	try {
		// Use direct axios call to avoid interceptor loop
		const response = await axios.post('/api/auth/refreshToken', { refresTkn });
		const { newRefreshToken, tokenn } = response.data;
		const userInfo = JSON.parse(localStorage.getItem('userInfo'));
		if (!userInfo) {
			const error = new Error('No user info available');
			error.code = 'NO_USER_INFO';
			throw error;
		}
		userInfo.token = tokenn;
		localStorage.removeItem('userInfo');
		localStorage.setItem('userInfo', JSON.stringify(userInfo));
		if (newRefreshToken) {
			localStorage.removeItem('refreshToken');
			localStorage.setItem('refreshToken', newRefreshToken);
		}
		return tokenn;
	} catch (error) {
		// Add error code for better error handling
		if (error.response?.status === 401) {
			error.code = 'REFRESH_TOKEN_EXPIRED';
		}
		throw error;
	}
}

export const signoutHandler = async () => {
	const refreshToken = localStorage.getItem('refreshToken');
	const userInfo = JSON.parse(localStorage.getItem('userInfo'));
	
	// Always clear localStorage first to prevent auto-login
	if (userInfo) {
		localStorage.removeItem('userInfo');
	}
	if (refreshToken) {
		localStorage.removeItem('refreshToken');
	}
	
	// Try to invalidate session on server (but don't block on error)
	if (userInfo && refreshToken) {
		try {
			await axios.post('/api/auth/logout', {
				refreshToken,
				userId: userInfo._id,
			});
		} catch (error) {
			// Log error but don't throw - user is already logged out locally
			console.error('SIGNOUT HANDLER ERROR: ', error);
		}
	}
	
	customHistory.push('/signin');
};

export const logoutHandler = async () => {
	// Get values before clearing
	const refreshToken = localStorage.getItem('refreshToken');
	const userInfo = JSON.parse(localStorage.getItem('userInfo'));
	
	// Clear localStorage immediately
	localStorage.clear();
	
	// Redirect immediately - don't wait for API call
	customHistory.push('/signin');
	
	// Try to invalidate session on server (but don't block)
	if (userInfo && refreshToken) {
		try {
			await axios.post('/api/auth/logout', {
				refreshToken,
				userId: userInfo._id,
			});
		} catch (error) {
			// Ignore errors - user is already logged out locally
			console.error('Error invalidating session on server:', error);
		}
	}
};

export function getToken() {
	const userInfo = JSON.parse(localStorage.getItem('userInfo'));
	const token = userInfo ? userInfo.token : null;
	return token;
}

export function getUserInfo() {
	const userInfo = JSON.parse(localStorage.getItem('userInfo'));
	return userInfo;
}

/**
 * Initials for an avatar/identity tile, e.g. "Lucia Martinez" -> "LM".
 * Falls back to the first two letters of a single-word name.
 */
export function getInitials(name) {
	if (!name) {
		return '?';
	}
	const parts = name.trim().split(/\s+/);
	const initials = parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : parts[0].slice(0, 2);
	return initials.toUpperCase();
}

/**
 * Validates the token stored in localStorage by attempting to refresh it.
 * If validation fails (token is invalid or from another app), clears localStorage.
 * This prevents conflicts when multiple apps share the same localStorage keys.
 */
export async function validateAndClearInvalidToken() {
	const userInfo = getUserInfo();
	const refreshToken = localStorage.getItem('refreshToken');
	
	// If no userInfo or refreshToken, nothing to validate
	if (!userInfo || !refreshToken) {
		return false;
	}

	try {
		// Try to refresh the token - if it fails, the token is invalid
		// Use direct axios call to avoid interceptor logic
		const response = await axios.post('/api/auth/refreshToken', { refresTkn: refreshToken });
		const { newRefreshToken, tokenn } = response.data;
		
		// Update tokens if refresh was successful
		if (tokenn) {
			userInfo.token = tokenn;
			localStorage.setItem('userInfo', JSON.stringify(userInfo));
			if (newRefreshToken) {
				localStorage.setItem('refreshToken', newRefreshToken);
			}
		}
		return true; // Token is valid
	} catch (error) {
		// Token is invalid (401 or other error) - clear localStorage silently
		// This is expected behavior when:
		// - Refresh token is expired (30 days passed)
		// - Session was deleted from database
		// - User logged out from another device
		// - Token is from another app instance
		// Only log unexpected errors (non-401)
		if (error.response && error.response.status !== 401) {
			console.error('Unexpected error validating token:', error);
		}
		localStorage.clear();
		return false; // Token is invalid
	}
}

/* for show data in tables: types string, currency(gotaccount case), boolean(show 'Si', o 'No', and date, also set link option to true,
and a pathLink , to sho the data as a link, the toExport option, is to show the data to export, but not in the screen) */

export	const accountColumns = [
	{ name: {type: 'string', get label() { return getLabel('field.name'); }, link:true}},
	{ type: {type: 'string', get label() { return getLabel('field.type'); }} },
	{ currency: { type: 'string', get label() { return getLabel('field.currency'); } }},
	{ folder: { type: 'string', get label() { return getLabel('field.folder'); } }}
];

export const contactsColumns = [
	{ 'account.name':{type: 'string', get label() { return getLabel('entity.account'); }, link:true}},
	{ name:{type:'string', get label() { return getLabel('field.name'); } }},
	{ email:{type: 'string', get label() { return getLabel('field.email'); } }},
	{ address:{ type: 'string', get label() { return getLabel('field.address'); } }},
	{ phone:{ type: 'string', get label() { return getLabel('field.phone'); }}},
	{ folder:{type: 'string', get label() { return getLabel('field.folder'); }}}
];

export const contractsColumns = [
	{ customId: { type: 'string', get label() { return getLabel('field.contract'); }, link: true } },
	{ currency: { type: 'string', get label() { return getLabel('field.currency'); }, toExport: true } },
	{ amount: { type: 'currency', get label() { return getLabel('field.amount'); } } },
	{ periodInit: { type: 'date', get label() { return getLabel('field.periodInit'); } } },
	{ periodEnd: { type: 'date', get label() { return getLabel('field.periodEnd'); } } },
	{ 'owner.name': { type: 'string', get label() { return getLabel('entity.tenant'); }, link:true } },
	{ folder: { type: 'string', get label() { return getLabel('field.folder'); } } },
	{ closeDate: { type: 'date', get label() { return getLabel('field.closeDate'); }} },
	{ previousDebt: { type: 'string', get label() { return getLabel('field.previousBalance'); }, toExport: true } },
	{ previousDebtDate: { type: 'date', get label() { return getLabel('field.previousBalanceDate'); }, toExport: true } },
	{ field: { type: 'string', get label() { return getLabel('field.details'); }, toExport: true } },
	{ paymentMethod: { type: 'string', get label() { return getLabel('field.paymentMethod'); }, toExport: true } },
	{ observations: { type: 'string', get label() { return getLabel('field.observations'); }, toExport: true } },
	{lastAdjustmentDate:{type:'date', get label() { return getLabel('field.lastAdjustmentDate'); }, toExport: true}} ,
	{lastAdjustmentIpc:{type:'string', get label() { return getLabel('field.lastAdjustmentIpc'); }, toExport: true}} ,
];

export const debtsColumns = [
	{ customId:{type: 'string', get label() { return getLabel('field.accountConcept'); },link:true}},
	{ 'owner.name':{ type: 'string', get label() { return getLabel('entity.account.debtor'); } ,link:true}},
	{ capital: {type:'currency', get label() { return getLabel('field.capital'); } }},
	{ concept:{type: 'string', get label() { return getLabel('entity.concept'); } }},
	{ dues: {type: 'number', get label() { return getLabel('entity.due.plural'); } }},
	{ amount: {type: 'currency', get label() { return getLabel('field.dueAmount'); } }},
	{ date: {type: 'date', get label() { return getLabel('field.date'); } }},
	{ endDate:{ type: 'date', get label() { return getLabel('field.endDate'); } }},
	{ periodicity:{type: 'string', get label() { return getLabel('field.periodicity'); }}},
	{ currency:{type: 'string', get label() { return getLabel('field.currency'); }, toExport: true }},
	{ previousDebt:{type: 'string', get label() { return getLabel('field.previousDebt'); }, toExport: true }},
	{ previousDebtDate:{type: 'date', get label() { return getLabel('field.previousDebtDate'); }, toExport: true }},
	{ interest:{type: 'string', get label() { return getLabel('field.interestPercent'); }, toExport: true }},
	{ lastPaymentDate:{type:'date', get label() { return getLabel('field.lastPaymentDate'); }, forReport:true} },
];

export const creditsColumns = [
	{ customId: {type: 'string', get label() { return getLabel('field.accountConcept'); }, link: true} },
	{ 'owner.name': {type: 'string', get label() { return getLabel('entity.account.creditor'); }, link: true} },
	{ capital: {type: 'currency', get label() { return getLabel('field.capital'); }} },
	{ concept: {type: 'string', get label() { return getLabel('entity.concept'); }} },
	{ dues: {type: 'number', get label() { return getLabel('entity.due.plural'); }} },
	{ amount: {type: 'currency', get label() { return getLabel('field.dueAmount'); }} },
	{ date: {type: 'date', get label() { return getLabel('field.date'); }} },
	{ endDate: {type: 'date', get label() { return getLabel('field.endDate'); }} },
	{ periodicity: {type: 'string', get label() { return getLabel('field.periodicity'); }} },
	{ guaranteedAmount: {type: 'currency', get label() { return getLabel('field.totalGuaranteed'); }} },
	{ currency: {type: 'string', get label() { return getLabel('field.currency'); }, toExport: true} },
];

export const assetsColumns = [
	{ name:{type: 'string', get label() { return getLabel('entity.asset'); },link:true }},
	{ 'owner.name':{type: 'string', get label() { return getLabel('entity.assetOwner'); },link:true}},
	{ currency:{type: 'string', get label() { return getLabel('field.currency'); }, toExport: true }},
	{ price:{type: 'currency', get label() { return getLabel('field.price'); } }},
	{ type:{type: 'string', get label() { return getLabel('field.type'); } }},
	{ ubication:{type: 'string', get label() { return getLabel('field.ubication'); } }},
	{ description:{type: 'string', get label() { return getLabel('field.description'); }}},
	{ folder:{type: 'string', get label() { return getLabel('field.folder'); }}},
	{ observations:{type: 'string', get label() { return getLabel('field.observations'); }, toExport: true}},
	{ guaranteedAmount:{type:'currency', get label() { return getLabel('field.guaranteedAmount'); }}},
	{ multipleLots:{type:'boolean', get label() { return getLabel('field.multipleLots'); }}},
	{ lot:{type: 'string,', get label() { return getLabel('field.lot'); }}},
];
export const paymentsColumns = [
	{ customId:{type: 'string', get label() { return getLabel('field.id'); }, link:true }},
	{ 'debtDue.customId':{type: 'string', get label() { return getLabel('entity.due'); }}},
	{ amount:{type: 'currency', get label() { return getLabel('field.amount'); }}},
	{ date:{type: 'date', get label() { return getLabel('field.date'); }}},
	{ folder:{type: 'string', get label() { return getLabel('field.folder'); }}},
	{ observations:{type: 'string', get label() { return getLabel('field.observations'); }, toExport: true }},
	{ status:{type: 'string', get label() { return getLabel('field.status'); }}},
];
export const creditPaymentsColumns = [
	{ customId: { type: 'string', get label() { return getLabel('field.id'); } } },
	{ 'creditDue.customId': { type: 'string', get label() { return getLabel('entity.due'); } } },
	{ amount: { type: 'currency', get label() { return getLabel('field.amount'); } } },
	{ date: { type: 'date', get label() { return getLabel('field.date'); } } },
	{ folder: { type: 'string', get label() { return getLabel('field.folder'); } } },
	{ 'credit.currency': { type: 'string', get label() { return getLabel('field.currency'); }, toExport: true } },
	{ observations: { type: 'string', get label() { return getLabel('field.observations'); }, toExport: true } }
];

export const relWarrantiesColumns = [
	{ 'warranty.option': { type: 'string', get label() { return getLabel('field.option'); } } },
	{ 'warranty.debt.customId': { type: 'string', get label() { return getLabel('entity.debt'); } } },
	{ 'warranty.debt.currency': { type: 'string', get label() { return getLabel('field.debtCurrency'); }, toExport: true } },
	{ 'warranty.asset.customId': { type: 'string', get label() { return getLabel('entity.asset'); } } },
	{ 'warranty.asset.currency': { type: 'string', get label() { return getLabel('field.assetCurrency'); }, toExport: true } },
	{ 'warranty.amount': { type: 'currency', get label() { return getLabel('field.amount'); } } }
];

export const debtDuesColumns = [
	{ customId: { type: 'string', get label() { return getLabel('entity.due'); } } },
	{ date: { type: 'date', get label() { return getLabel('field.date'); } } },
	{ interest: { type: 'currency', get label() { return getLabel('field.interest'); } } },
	{ 'debt.currency': { type: 'currency', get label() { return getLabel('field.currency'); } } },
	{ amortization: { type: 'currency', get label() { return getLabel('field.amortization'); } } },
	{ amount: { type: 'currency', get label() { return getLabel('field.amount'); } } },
	{ expiration: { type: 'date', get label() { return getLabel('field.expiration'); } } },
	{ balance: { type: 'currency', get label() { return getLabel('field.balance'); } } },
	{ surcharge: { type: 'currency', get label() { return getLabel('field.surcharge'); } } },
	{ unpaidAmount: { type: 'currency', get label() { return getLabel('field.unpaidAmount'); } } },
	{ paid: { type: 'boolean', get label() { return getLabel('field.paid'); } } },
	{ 'debt.customId': { type: 'string', get label() { return getLabel('entity.account.debtor'); }, toExport: true } },
	{ 'debt.concept': { type: 'string', get label() { return getLabel('entity.concept'); }, toExport: true } },
	{ status:{type: 'string', get label() { return getLabel('field.status'); }}},
	{ lastPaymentDate:{type:'date', get label() { return getLabel('field.lastPaymentDate'); }, forReport:true} },
];

export const creditDuesColumns = [
	{ customId: { type: 'string', get label() { return getLabel('entity.due'); } } },
	{ date: { type: 'date', get label() { return getLabel('field.date'); } } },
	{ 'credit.customId': { type: 'string', get label() { return getLabel('entity.account.creditor'); } } },
	{ interest: { type: 'currency', get label() { return getLabel('field.interest'); } } },
	{ 'credit.currency': { type: 'currency', get label() { return getLabel('field.currency'); } } },
	{ amortization: { type: 'currency', get label() { return getLabel('field.amortization'); } } },
	{ amount: { type: 'currency', get label() { return getLabel('field.amount'); } } },
	{ expiration: { type: 'date', get label() { return getLabel('field.expiration'); } } },
	{ unpaidAmount: { type: 'currency', get label() { return getLabel('field.unpaidAmount'); } } },
	{ paid: { type: 'boolean', get label() { return getLabel('field.paid'); } } },
];

export const billsColumns = [
	{ name: { type: 'string', get label() { return getLabel('field.name'); }, link:true} },
	{ 'asset.currency': { type: 'string', get label() { return getLabel('field.currency'); }, toExport: true } },
	{ amount: { type: 'currency', get label() { return getLabel('field.amount'); } } },
	{ expirationDate: { type: 'date', get label() { return getLabel('field.expirationDate'); } } },
	{ type: { type: 'string', get label() { return getLabel('field.type'); } } },
	{ periodicity: { type: 'string', get label() { return getLabel('field.periodicity'); } } },
	{ 'billTemplate.active': { type: 'boolean', get label() { return getLabel('field.active'); } } },
	{ paid: { type: 'boolean', get label() { return getLabel('field.paid'); } } },
	{ observations: { type: 'string', get label() { return getLabel('field.observations'); }, toExport: true } }
];

export const parsePeriodicity = (period) => {
	switch (period) {
	case '1':
		return 'Mensual';
	case '2':
		return 'Bimensual';
	case '3':
		return 'Trimestral';
	case '4':
		return 'Cuatrimestral';
	case '6':
		return 'Semestral';
	case '12':
		return 'Anual';
	case '999':
		return 'Cada 2 minutos';
	default:
		return period;
	}
};

export const assetSalesColumns = [
	{ customId: { type: 'string', get label() { return getLabel('field.id'); }, link:true} },
	{ date: { type: 'date', get label() { return getLabel('field.date'); }} },
	{ lot: { type: 'string', get label() { return getLabel('field.lotUpper'); } } },
	{ currency: { type: 'currency', get label() { return getLabel('field.currency'); }, toExport:true } },
	{ amount: { type: 'currency', get label() { return getLabel('field.amount'); } } },
	{ 'purchaser.name': { type: 'string', get label() { return getLabel('entity.purchaser'); }} },
	{ sumDebts: { type: 'currency', get label() { return getLabel('field.totalDebts'); } } },
	{ initialPayment: { type: 'currency', get label() { return getLabel('field.initialPayment'); } } },
	{'asset.name':{type:'string', get label() { return getLabel('field.property'); }, link:true, forReport:true}}

];

export const objectsTranslation = {
	accounts: 'cuentas',
	debts: 'deudas',
	credits: 'pasividades',
	contracts: 'alquileres',
	assets: 'activos Fijos',
	reports: 'reportes',
	bills: 'gastos',
	assetSale: 'ventas',
	predictions: 'previsiones',
};

/**
 * Convert a base64 string to an ArrayBuffer.
 * Used to load DOCX templates from the backend into the DocxEditor.
 */
export const base64ToArrayBuffer = (base64) => {
	const binary = atob(base64);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i++) {
		bytes[i] = binary.charCodeAt(i);
	}
	return bytes.buffer;
};

/**
 * Convert an ArrayBuffer to a base64 string.
 * Used to send DOCX buffers from DocxEditor to the backend.
 */
export const arrayBufferToBase64 = (buffer) => {
	const bytes = new Uint8Array(buffer);
	let binary = '';
	for (let i = 0; i < bytes.byteLength; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	return btoa(binary);
};